export class ItinerariesApiRoutes {
  public static ROUTE = 'route';
  public static CODE = 'code';
}
